import { Box, styled } from "@mui/material";
const EndAdornmentContainer = styled(Box, {
  name: "SectionContainer",
  slot: "endAdornment"
})`
  align-items: center;
  display: flex;
  width: auto;
  margin-left: auto;
`;
export {
  EndAdornmentContainer
};
//# sourceMappingURL=EndAdornmentContainer.js.map
